export const BUILD_STOP_CAUSES = [
    "toolchain_missing",
    "checks_could_not_run",
    "env_needs_you",
    "env_install_failed",
    /** The sandbox's disk filled twice in a session, after its one cleanup. */
    "env_disk_full",
    "credential_missing",
    "run_budget",
    "workspace_credits",
    "guardian_cap",
    "harness_start",
    "substrate",
    "infra",
    "timeout",
    "round_cap",
    "scope",
    "model",
    "merge_unresolved",
    "no_commit",
    "checks_left_failing",
    "credential_in_change",
    "binary_in_change",
    "change_too_large",
    "run_request_limit",
    /** The ticket used its one budget (planning, build and fix rounds together). */
    "ticket_budget",
    /**
     * A one-attempt session's own pipeline failed partway (its report says
     * `failed`) and nothing in the report names a cause above (YAG-1051).
     */
    "session_failed",
    "unknown",
];
export const BUILD_STOP_CAUSE_WORDS = {
    toolchain_missing: "a tool the checks need is not in the sandbox",
    checks_could_not_run: "the checks could not run",
    env_needs_you: "the repository's setup is waiting on an answer from you",
    env_install_failed: "the repository's setup could not install",
    env_disk_full: "the repository's services need more disk than the sandbox has",
    credential_missing: "a credential the build needs is missing or was refused",
    run_budget: "it reached this run's approved budget",
    workspace_credits: "the workspace ran out of credits",
    guardian_cap: "the command reviewer reached its hourly limit",
    harness_start: "the build did not start in its sandbox",
    substrate: "the sandbox's machine failed on our side",
    infra: "a problem on our side",
    timeout: "build timed out",
    round_cap: "the review rounds ran out",
    scope: "the change went outside the approved plan",
    model: "the model was too slow to finish",
    merge_unresolved: "it left merge conflicts it could not resolve",
    no_commit: "it changed no file",
    checks_left_failing: "checks still fail and the round changed nothing",
    credential_in_change: "the change contains a credential from Wright's own session",
    binary_in_change: "the change adds a binary file that is not an image",
    change_too_large: "the change is too big to review",
    run_request_limit: "it used all the model calls this run allows",
    ticket_budget: "the ticket used its budget",
    session_failed: "the session failed before it finished",
    unknown: "stopped",
};
/**
 * Which of the two customer classes each cause is (`stopClass.ts`). `infra`
 * retries and then leaves a note; `person` is the one gate a person answers.
 * A cause the machine could not name (`unknown`) is ours: it never asks, and
 * neither does a session that failed for a reason its report does not name
 * (`session_failed`): the lane retried it before it handed it off.
 * `run_budget` and `round_cap` are the old per-run budget and fix-round cap,
 * kept for the rows written before the ticket budget; they read as the
 * budget stop does.
 */
export const BUILD_STOP_CAUSE_CLASS = {
    toolchain_missing: "infra",
    checks_could_not_run: "infra",
    env_needs_you: "person",
    env_install_failed: "infra",
    env_disk_full: "person",
    credential_missing: "person",
    run_budget: "person",
    workspace_credits: "person",
    guardian_cap: "infra",
    harness_start: "infra",
    substrate: "infra",
    infra: "infra",
    timeout: "infra",
    round_cap: "person",
    scope: "person",
    model: "infra",
    merge_unresolved: "person",
    no_commit: "person",
    checks_left_failing: "person",
    credential_in_change: "person",
    binary_in_change: "person",
    change_too_large: "person",
    run_request_limit: "infra",
    ticket_budget: "person",
    session_failed: "infra",
    unknown: "infra",
};
const CAUSES = new Set(BUILD_STOP_CAUSES);
export function isBuildStopCause(value) {
    return typeof value === "string" && CAUSES.has(value);
}
/** The class of a stored cause; a value this code does not know reads as `infra`, ours. */
export function buildStopCauseClass(cause) {
    return isBuildStopCause(cause) ? BUILD_STOP_CAUSE_CLASS[cause] : "infra";
}
//# sourceMappingURL=buildStopCause.js.map